export default "__VITE_ASSET__BICtFg9W__"